import axios from "axios";

export const state = {
    studentattendances: [],
};

export const getters = {
    studentattendances: state => state.studentattendances,
};

export const mutations = {
    setStudentattendances(state, newValue) {
        state.studentattendances = newValue
    },
};

export const actions = {
    fetchStudentattendances({ commit }) {
        axios.get('/studentattendances').then(res => {
            commit('setStudentattendances', res.data.attendances);
        })
    },
};
